
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_sud5v_97",
  "disabled": "awsui_disabled_8cbea_sud5v_177",
  "selected": "awsui_selected_8cbea_sud5v_185",
  "icon": "awsui_icon_8cbea_sud5v_206",
  "with-text": "awsui_with-text_8cbea_sud5v_210",
  "with-no-text": "awsui_with-no-text_8cbea_sud5v_216",
  "root": "awsui_root_8cbea_sud5v_225",
  "segment-part": "awsui_segment-part_8cbea_sud5v_260",
  "select": "awsui_select_8cbea_sud5v_185",
  "segment-count-2": "awsui_segment-count-2_8cbea_sud5v_279",
  "segment-count-3": "awsui_segment-count-3_8cbea_sud5v_284",
  "segment-count-4": "awsui_segment-count-4_8cbea_sud5v_289",
  "segment-count-5": "awsui_segment-count-5_8cbea_sud5v_294",
  "segment-count-6": "awsui_segment-count-6_8cbea_sud5v_299"
};
  